import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { server } from "../../server";
import { useNavigate } from 'react-router-dom';
import MemberDetails from './MemberDetails';

const StudioAdminDashboard = () => {
    const [members, setMembers] = useState([]);
    const [filteredMembers, setFilteredMembers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedMember, setSelectedMember] = useState(null);
    const [inviteEmail, setInviteEmail] = useState('');
    const [sendingInvite, setSendingInvite] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchMembers = async () => {
            try {
                const response = await axios.get(`${server}/membership/members`); 
                setMembers(response.data);
                setFilteredMembers(response.data)
            } catch (error) {
                console.error('Error fetching members:', error);
                toast.error('Failed to fetch members.');
            }
        };

        fetchMembers();
    }, []);

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        const filtered = members.filter(member => 
            member.firstName.toLowerCase().includes(value) || 
            member.lastName.toLowerCase().includes(value)
        );
        setFilteredMembers(filtered);
    };

    const handleMemberClick = (member) => {
        setSelectedMember(member);
    };

    const handleCloseDetails = () => {
        setSelectedMember(null);
    };

    const handleSendInvite = async (event) => {
        event.preventDefault();
        setSendingInvite(true);

        try {
            await axios.post(`${server}/user/signup-invites`, { email: inviteEmail }, { withCredentials: true });
            toast.success('MATRIX signup invitation sent.');
            setInviteEmail('');
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to send invitation.');
        } finally {
            setSendingInvite(false);
        }
    };

    return (
        <div className="membership-admin-dashboard">
            <img
                className="membership-admin-logo"
                src="https://www.churchofmatrix.org/assets/images/matrix-avatar.png"
                alt="Church of Matrix"
            />
            <h1>Admin Dashboard</h1>
            <button 
                className="membership-qr-scanner-button"
                onClick={() => navigate('/admin-studio-qr-scanner')}
            >
                Open QR Scanner
            </button>
            <form onSubmit={handleSendInvite}>
                <label htmlFor="matrix-invite-email">Invite congregation member</label>
                <input
                    id="matrix-invite-email"
                    type="email"
                    placeholder="member@example.com"
                    value={inviteEmail}
                    onChange={(event) => setInviteEmail(event.target.value)}
                    className="membership-search-bar"
                    required
                />
                <button
                    type="submit"
                    className="membership-qr-scanner-button"
                    disabled={sendingInvite}
                >
                    {sendingInvite ? 'Sending...' : 'Send Signup Invitation'}
                </button>
            </form>
            <input 
                type="text" 
                placeholder="Search by name..." 
                value={searchTerm} 
                onChange={handleSearch} 
                className="membership-search-bar"
            />

            {/* Table for larger screens */}
            <table className="membership-members-table">
                <thead>
                    <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Date of Birth</th>
                    <th scope="col">Membership Status</th>
                    <th scope="col">Signed In Status</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredMembers.map((member) => (
                    <tr
                        key={member._id}
                        className={`${
                        member.isSignedIn ? "membership-member-signed-in" : ""
                        } ${member.status === "canceled" ? "membership-member-canceled" : ""}`}
                        onClick={() => handleMemberClick(member)}
                    >
                        <td className="member-info">
                        <div className="member-details">
                            <img src={member.photo} alt={`${member.firstName} ${member.lastName}`} className="member-photo" />
                            <div className="member-text">
                            <div className="member-name">{member.firstName} {member.lastName}</div>
                            <div className="member-email">{member.email}</div>
                            </div>
                        </div>
                        </td>
                        <td>{member.email}</td>
                        <td>{new Date(member.dob).toLocaleDateString()}</td>
                        <td>{member.status}</td>
                        <td>{member.isSignedIn ? 'Signed In' : 'Signed Out'}</td>
                    </tr>
                    ))}
                </tbody>
                </table>


            {/* Card layout for small screens */}
            <div className="membership-card-list">
                {filteredMembers.map(member => (
                    <div 
                        key={member._id} 
                        className={`membership-card ${member.isSignedIn ? 'membership-member-signed-in' : ''} ${member.status === 'canceled' ? 'membership-member-canceled' : ''}`} 
                        onClick={() => handleMemberClick(member)}
                    >
                        <img src={member.photo} alt={`${member.firstName} ${member.lastName}`} className="membership-member-photo" />
                        <div className="membership-card-info">
                            <h3>{member.firstName} {member.lastName}</h3>
                            <span>{member.email}</span>
                            <span>{new Date(member.dob).toLocaleDateString()}</span>
                            <span>{member.status}</span>
                            <span>{member.isSignedIn ? 'Signed In' : 'Signed Out'}</span>
                        </div>
                    </div>
                ))}
            </div>


            {selectedMember && (
                <MemberDetails member={selectedMember} onClose={handleCloseDetails} />
            )}
        </div>
    );
};

export default StudioAdminDashboard;


